module.exports = __webpack_public_path__ + "img/close.90203913.svg";